export const ru = {
    news: 'Новости'
};
